export interface ViewPhotoI {
  uuid: string;
  src: string;
  observation: string;
  order: number;
}

/**
 * Une las fotos legacy (con src) y las fotos de StorageFile para los visores
 * de solo lectura (modal "Ver" y página pública del QR).
 */
export const getViewPhotos = (data: any): ViewPhotoI[] => {
  const photos: ViewPhotoI[] = [];

  for (const p of data?.photos ?? []) {
    if (!p?.src) continue;
    photos.push({
      uuid: p.uuid ?? `legacy_${photos.length + 1}`,
      src: p.src,
      observation: p.observation ?? "",
      order: photos.length + 1,
    });
  }

  for (const s of data?.storagePhotos ?? []) {
    if (!s?.url) continue;
    photos.push({
      uuid: `storage_${s.id ?? photos.length + 1}`,
      src: s.url,
      observation: "",
      order: photos.length + 1,
    });
  }

  return photos;
};
